import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const FcmSetupWidget: WidgetRegistryEntry = {
  name: "FcmSetup",
  component: () => import("./fcm-setup-widget.component").then((module) => module.FcmSetupWidgetComponent),
  configuration: () => import("./configuration").then((module) => module.FcmSetupWidgetComponent)
};
